import React, {useEffect, useMemo, useRef, useState} from "react";
import HistoryListType from "./HistoryListType";
import {toKSTISOString, toKSTISOStringEnd} from "../../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import useRequestData from "../../../../hooks/useRequestData";
import {getHistoryList} from "../../../../api/history/HistoryService";
import {HISTORY_HEADER} from "../../../../components/table/header/Headers";

/**
 * @param {"entity"|"asset"} queryMode
 *   - entity: 단일 문서(구매·라이선스 상세 등) — entityName + entityId
 *   - asset: 자산 상세 — 연결된 구매·라이선스 등 포함 assetId 기준 조회
 */
function CommonHistoryList({id, tableName}) {
    const [checked, setChecked] = useState([]);
    const initDate = useMemo(
        () => ({
            startDate: toKSTISOString(addYears(new Date(), -1)),
            endDate: toKSTISOStringEnd(addYears(new Date(), 0)),
        }),
        []
    );


    const {newData, pageInfo, dataHook} = useRequestData((conditions, pageable) => {
        const historyType = conditions.historyType || "A";
        const base = {
            ...initDate,
            ...conditions,
            historyType,
        };

        let finalConditions= {...base, entityName: tableName, entityId: id};

        return getHistoryList(finalConditions, pageable);
    }, initDate);

    const mountedRef = useRef(false);
    useEffect(() => {
        if (id == null) return;
        if (!mountedRef.current) {
            mountedRef.current = true;
            return;
        }
        dataHook.refresh();
    }, [id, tableName]);

    return (
        <div className="detail-view-tab-panel flex min-h-0 min-w-0 flex-1 flex-col w-full h-full">
            <HistoryListType
                checked={{checked: checked, setChecked: setChecked}}
                data={newData}
                date={initDate}
                pageInfo={pageInfo}
                dataHook={dataHook}
                header={HISTORY_HEADER}
                type={"common_history"}
                linkedLayout
            />
        </div>
    );
}

export {CommonHistoryList};
